import { DropDownSliceData } from '@adapters/prismic/types/slices';
import * as Accordion from '@components/ui/Accordion';
import Heading from '@components/ui/Heading';
import MarkdownCopy from '../MarkdownCopy';

const DropDown = ({ title, copy, isOpen }: DropDownSliceData) => {
  return (
    <div>
      <Accordion.Container isOpen={isOpen}>
        <Accordion.Title>
          <Heading semanticLevel="h2" styleLevel="2">
            {title}
          </Heading>
        </Accordion.Title>
        <Accordion.Collapsible>
          <MarkdownCopy text={copy} />
        </Accordion.Collapsible>
      </Accordion.Container>
    </div>
  );
};

export default DropDown;
